import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TeamPerformanceDetail from "../components/team-detail/performance-detail";
import ReportHero from "../components/reports/reportHero";
import { useStateValue } from "../context/StateProvider";
import { getAlldealforAdmin } from "../utils/firebasefunctions";
import { actionType } from "../context/reducer";
import PageHeader from "../components/PageHeader";

const TABS = [
  { id: "performance", label: "Team Performance" },
  { id: "reports", label: "Reports" },
];

function TeamManagment() {
  const [isLoad, setIsLoad] = useState(false);
  const [, dispatch] = useStateValue();
  const location = useLocation();
  const navigate = useNavigate();

  const queryTab = new URLSearchParams(location.search).get("tab");
  const activeTab = TABS.some((t) => t.id === queryTab) ? queryTab : "performance";

  async function getalldeal() {
    await getAlldealforAdmin("deals")
      .then(async (response) => {
        dispatch({
          type: actionType.STORE_DEALS,
          deals: response,
        });
        setIsLoad(true);
      })
      .catch((err) => {
        alert(err);
        setIsLoad(true);
      });
  }

  useEffect(() => {
    getalldeal();
  }, []);

  const handleTabChange = (tabId) => {
    const params = new URLSearchParams(location.search);
    if (tabId === "performance") {
      params.delete("tab");
    } else {
      params.set("tab", tabId);
    }
    const search = params.toString();
    navigate(`${location.pathname}${search ? `?${search}` : ""}`, {
      replace: true,
    });
  };

  const noop = () => {};

  return (
    <div>
      <PageHeader title="Team Management" />
      <div className="px-4 lg:px-6 pt-4 border-b border-slate-200 bg-white">
        <div className="flex gap-1">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => handleTabChange(tab.id)}
              className={`px-4 py-2 text-sm font-semibold border-b-2 -mb-px transition ${
                activeTab === tab.id
                  ? "border-indigo-500 text-indigo-700"
                  : "border-transparent text-slate-500 hover:text-slate-700"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {isLoad && activeTab === "performance" && (
        <TeamPerformanceDetail teamView={true} childSelectedYear={noop} />
      )}
      {isLoad && activeTab === "reports" && <ReportHero />}
    </div>
  );
}

export default TeamManagment;
